import styled from "@emotion/styled"

const AspectRatio = styled.div`
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: calc(
      (${props => props.height} / ${props => props.width}) * 100%
    );
  }
  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`
export default AspectRatio
